import { Divider } from "@mui/material";
import { Msg } from "../../components/Msg";
import { useMsg } from "../../components/Msg/Msg";
import { ProgressStats } from "../../components/ProgressStats";
import { ScrollableRightMenu } from "../../components/ScrollableRightMenu";
import { P } from "../../components/Typography";
import { Loaders } from "../QM/QueryRenderer";
import { messages } from "./messages";
import { LinearProgressThick } from "../../components/Progress/LinearProgressThick";

export const FeedbackRightMenu = ({
  buttonProps,
  secondaryButtonProps,
  stats,
  collected,
  isPending,
  children,
}) => {
  const msg = useMsg({ dict: messages });

  // if (collected) {
  //   console.log({
  //     collected,
  //   });
  // }

  return (
    <ScrollableRightMenu
      heading={msg("feedback.aside.heading")}
      buttonProps={buttonProps}
      secondaryButtonProps={secondaryButtonProps}
    >
      <P gutterBottom emphasized>
        <Msg id="feedback.aside.text" />
      </P>
      <P>
        <Msg id="feedback.aside.perex" />
      </P>
      <Divider sx={{ my: 3 }} />
      {isPending ? (
        <Loaders.CircularBlock fullHeight />
      ) : (
        <>
          {stats ? <ProgressStats items={stats} /> : null}
          {collected ? (
            <>
              <Divider sx={{ my: 3 }} />
              <P gutterBottom emphasized>
                <Msg id="feedback.aside.collected" />
              </P>
              <LinearProgressThick
                variant="determinate"
                value={
                  !collected.total
                    ? 0
                    : (100 * collected.count) / collected.total
                }
                sx={{ my: 2 }}
              />
              <P>
                {collected.count}/{collected.total}
              </P>
            </>
          ) : null}
          {children}
        </>
      )}
    </ScrollableRightMenu>
  );
};
